// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1NefS","content":"ManualTimeModal_content__hPpnb"};